import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { User } from '@/modules/User/interfaces/user'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import { Insured } from '@/modules/Insured/interfaces/insured'
import { Property } from '@/modules/Property/interfaces/property'
import { File } from '@/modules/File/interfaces/file'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Note } from '@/modules/Case/interfaces/note'
import { AccountAsset } from '@/modules/Account/interfaces/account-asset'

export enum CaseType {
  BOR = 'BOR',
  REWRITE = 'REWRITE',
  REMARKET = 'REMARKET',
  CANCELLATION = 'CANCELLATION',
  RENEWAL = 'RENEWAL',
  ENDORSEMENT = 'ENDORSEMENT',
  NEW_BUSINESS = 'NEW_BUSINESS',
}

export enum CaseStatus {
  INQUIRY = 'Inquiry',
  QUOTE = 'Quote',
  UNDERWRITE = 'Underwrite',
  PROPOSAL = 'Proposal',
  BINDING = 'Binding',
  POST_BINDING = 'Post Binding',
  COMPLETED = 'Completed',
}

export enum CasePriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High'
}

export interface PhaseCases {
  type: string,
  cases: Case[],
}

export interface Case {
  id: number,
  inquiryName: string,
  type: CaseType,
  caseNote: string,
  closed: boolean
  status: CaseStatus,
  createdAt: string,
  updatedAt: string,
  ifNewProducer: boolean,
  recordType: RecordType,
  account: Account,
  primaryContact: Contact,
  assignedUsers: User[],
  policies: Policy[],
  quotes: Quote[],
  source: Producer,
  relatedQuotes: Quote[],
  relatedPolicies: Policy[],
  vehicles: Vehicle[],
  priority: CasePriority;
  createdBy: User,
  lastModifiedBy: User,
  additionalInfoStr: string
  attachments: File[];
  targetPolicy: Policy;
  properties: Property[];
  insureds: Insured[];
  caseManager: User;
  notes: Note[];
  closeDate: number;
  openDate: number;
  openDays?: number;
  important: boolean;
  urgent: boolean
  asset?: AccountAsset;
}
